import backend from '@common/backend';

const BASE = '/academicLevels';

export interface IGetLevelsQuery {
    academic_product_id?: number;
    page?: number;
    limit?: number;
}

export const getAcademicLevels = async (query?: IGetLevelsQuery) => backend.get(`${BASE}/`, {
    params: query,
});

export const getAcademicLevel = async (academic_level_id: number) => backend.get(`${BASE}/${academic_level_id}`);

export const postAcademicLevel = async (data: any) => backend.post(`${BASE}`, data);

export const deleteAcademicLevel = async (academic_level_id: number) => backend.delete(`${BASE}/${academic_level_id}`);

export const updateAcademicLevel = async (academic_level_id: number, data: any) => backend
    .put(`${BASE}/${academic_level_id}`, data);
